// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"ss_a bhj_a bhj_r bhj_j","Photos__img":"ss_b bhj_b"};